// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box-container[data-v-8d21ca5c]{display:flex}.box__content-container[data-v-8d21ca5c]{display:flex;width:80%;flex-wrap:wrap;margin-bottom:10px}.box[data-v-8d21ca5c]{width:10px;height:10px;flex:0 0 10px;margin:1px}.box__title[data-v-8d21ca5c]{opacity:0;transition:all .3s ease}.box__title--show[data-v-8d21ca5c]{opacity:1}@media screen and (max-width:1024px){.box[data-v-8d21ca5c]{width:5px;height:5px;flex:0 0 5px;margin:.5px}}", ""]);
// Exports
module.exports = exports;
